export default __webpack_public_path__ + "static/SkillsBridge-bfe3868a4641a754bcb41c3d79797e25.svg";